"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.authSelectors = void 0;
const all = state => state.auth;
const isAuthorized = state => all(state).isAuthorized;
const loginLoading = state => all(state).loginLoading;
const loginError = state => all(state).loginError;
const accessToken = state => all(state).accessToken;
const refreshToken = state => all(state).refreshToken;
const logoutLoading = state => all(state).logoutLoading;
const meLoading = state => all(state).meLoading;
const user = state => all(state).user;
const sessionHasExpired = state => all(state).sessionHasExpired;
const authSelectors = exports.authSelectors = {
  isAuthorized,
  loginLoading,
  loginError,
  accessToken,
  refreshToken,
  logoutLoading,
  meLoading,
  user,
  sessionHasExpired
};